jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);


	   });

      // 延迟设置chatwithus按钮优先级
      setTimeout(function() {
        const tidioChat = document.getElementById('tidio-chat');
        if (tidioChat) {
          tidioChat.style.zIndex = '467';
        } else {
          console.error('未找到 #tidio-chat 元素！');
        }
      }, 5000);
  
});



